import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PrepTourModule } from 'src/@prep/shared/tour';
import { GuidedWorkflowLauncherComponent } from './components/guided-workflow-launcher.component';

/**
 * "Start work" — the guided path from upload to export. Import in the
 * toolbar (launcher) and in every screen that registers workflow anchors
 * (dashboard, upload, remediation); re-exports the tour engine's outlet and
 * anchor directive.
 */
@NgModule({
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule, PrepTourModule],
  declarations: [GuidedWorkflowLauncherComponent],
  exports: [GuidedWorkflowLauncherComponent, PrepTourModule],
})
export class GuidedWorkflowModule {}
